import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { Book } from "../../types/types";
export type AddBookDTO = Book

type BookResponse  = AddBookDTO & {
    id:string;
    createdAt:string;
    updatedAt:string;
} & ApiError;

export const AddNewBook = (data: AddBookDTO): Promise<BookResponse> => {
    return axios.post("/book/create", data)
        .then(response => response.data as BookResponse);
};